import React from "react";
import MeasureDetails from "../components/MeasureDetails";
import axios from "../util/Api";
import { tokensKey } from "../util/Constants";
import "antd/dist/antd.css";
import { Spin, Modal } from "antd";
import "flatpickr/dist/themes/light.css";
import getStorage from "../context/auth";

class UpdatedData extends React.Component {
  constructor(props) {
    super(props);
    this.getMeasures = this.getMeasures.bind(this);
    this.getRecentShares = this.getRecentShares.bind(this);
    this.state = {
      sectionNumber: 0,
      searchContent: "",
      isModalOpen: false,
      loading: false,
      measures: [],
      selectedElement: null
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getMeasures();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleClose = () => {
    if (this._isMounted) {
      this.setState({ isModalOpen: false });
    }
  };

  handleOk = () => {
    if (this._isMounted) {
      this.setState({ isModalOpen: false });
    }
  };

  getMeasures() {
    if (this._isMounted) {
      this.setState({ loading: true });
    }
    const tokensData = getStorage().getItem(tokensKey);
    if (!tokensData) return;
    const { jwt, user } = JSON.parse(tokensData);
    console.log("JWT", jwt);
    if (jwt) {
      axios
        .get(`api/mesures/latest?id=${user.id}`, {
          headers: { Authorization: `Bearer ${jwt}` }
        })
        .then(result => {
          if (result.status === 200 && this._isMounted) {
            let measures = result.data;
            this.setState({ measures, loading: false });
          }
        })
        .catch(e => {
          if (this._isMounted) {
            this.setState({ loading: false });
          }
        });
    }
  }

  getRecentShares() {
    if (this._isMounted) {
      this.setState({ loading: true });
    }
    console.log("Local storage", getStorage().getItem(tokensKey));
    const tokensData = getStorage().getItem(tokensKey);
    if (!tokensData) return;
    const { jwt, user } = JSON.parse(tokensData);
    console.log("JWT", jwt);
    if (jwt) {
      axios
        .get(`api/mesures/shares?id=${user.id}`, {
          headers: { Authorization: `Bearer ${jwt}` }
        })
        .then(result => {
          if (result.status === 200 && this._isMounted) {
            console.log(result.data);
            this.setState({ measures: result.data, loading: false });
          }
        })
        .catch(e => {
          if (this._isMounted) {
            this.setState({ loading: false });
          }
        });
    }
  }

  render() {
    const { sectionNumber, loading, measures, isModalOpen, selectedElement } = this.state;

    return (
      <section className="section">
        <div className="container">
          <div className="row mt-4 pt-2 justify-content-center">
            <div className="col-lg-8 col-md-12 text-center">
              <ul
                className="nav nav-pills rounded nav-justified flex-column flex-sm-row"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item">
                  <a
                    className={`nav-link rounded ${sectionNumber === 0 ? "active" : ""}`}
                    id="pills-dayone-tab"
                    data-toggle="pill"
                    role="tab"
                    aria-controls="pills-dayone"
                    aria-selected="false"
                    onClick={e => {
                      if (this._isMounted) {
                        this.setState({ sectionNumber: 0 });
                      }
                      this.getMeasures();
                    }}
                  >
                    <div className="text-center pt-1 pb-1">
                      <h4
                        className={`title ${sectionNumber === 0 ? "font-weight-bold text-light" : "font-weight-normal"
                          } mb-0`}
                      >
                        Dernières mesures
                      </h4>
                    </div>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link rounded ${sectionNumber === 1 ? "active" : ""}`}
                    id="pills-daytwo-tab"
                    data-toggle="pill"
                    role="tab"
                    aria-controls="pills-daytwo"
                    aria-selected="false"
                    onClick={e => {
                      if (this._isMounted) {
                        this.setState({ sectionNumber: 1 });
                      }
                      this.getRecentShares();
                    }}
                  >
                    <div className="text-center pt-1 pb-1">
                      <h4
                        className={`title ${sectionNumber === 1 ? "font-weight-bold text-light" : "font-weight-normal"
                          } mb-0`}
                      >
                        Bons partagés
                      </h4>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {loading ? (
            <div className="row justify-content-center">
              <Spin />
            </div>
          ) : measures && measures.length === 0 ? (
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card features px-md-3 border-0 text-center">
                  <div className="icons rounded h1 text-center text-primary px-3">
                    <i className={`uil ${sectionNumber === 0 ? "uil-file-alt" : "uil-file-share-alt"}`} />
                  </div>
                  <div className="card-body p-0 content">
                    <h5 className="mt-4">
                      <a href="javascript:void(0)" className="title text-dark">
                        {sectionNumber === 0 ? "Pas de mesures" : "Pas de partages"}
                      </a>
                    </h5>
                    <p className="text-muted">
                      {sectionNumber === 0
                        ? "Y a pas encore des mesures ajoutées, les mesures vont apparaitre dans cette section prochainement"
                        : "Aucun client n'a partagé une mesure avec vous, les mesures partagées vont apparaitre dans cette section prochainement"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <div className="tab-content">
                  <div className="tab-pane fade show active" role="tabpanel">
                    <div className="row">
                      {measures &&
                        measures.map(measure => (
                          <div className="col-lg-6 mt-4 pt-2" key={measure.id}>
                            <div className="card event-schedule rounded border">
                              <div className="card-body">
                                <div className="media">
                                  <ul className="date text-center text-primary mr-3 mb-0 list-unstyled">
                                    <li className="day font-weight-bold mb-2">
                                      {measure.date && measure.date.split(" ")[0]}
                                    </li>
                                    <li className="month font-weight-bold">
                                      {measure.date && measure.date.split(" ")[1]}
                                    </li>
                                  </ul>
                                  <div className="media-body content">
                                    <h4>
                                      <a href="javascript:void(0)" className="text-dark title">
                                        {measure.boat}
                                      </a>
                                    </h4>
                                    <p className="text-muted location-time">
                                      <span className="text-dark h6">Tonnage jaugé : </span>
                                      {measure.tonnage}
                                    </p>
                                    <a
                                      className="btn btn-sm btn-outline-primary mouse-down"
                                      onClick={e => {
                                        if (this._isMounted) {
                                          this.setState({
                                            selectedElement: measure,
                                            isModalOpen: true
                                          });
                                        }
                                      }}
                                    >
                                      Détails
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <Modal
          visible={isModalOpen}
          onOk={this.handleOk}
          onCancel={this.handleClose}
          cancelText={"Annuler"}
          width={1000}
          footer={[]}
        >
          {selectedElement && (
            <MeasureDetails
              updatedUser={this.props.updatedUser}
              selectedElement={selectedElement.id}
              onUpdated={e => {
                this.getMeasures();
                if (this._isMounted) {
                  this.setState({ isModalOpen: false });
                }
              }}
              onLiteUpdated={e => {
                this.getMeasures();
              }}
            />
          )}
        </Modal>
      </section>
    );
  }
}

export default UpdatedData;